import Logo from "../../assets/default/logo.png";
import LogoSvg from "../../assets/default/logo2.svg";
import Bg from "../../assets/default/bg.png";
import Clients from "../../assets/default/clients.png";
import SignupFormIcon from "../../assets/signup/signup-form.png";

import Retro from "../../assets/services/retro.png";
import Waterproofing from "../../assets/services/waterproofing.png";
import Envcoating from "../../assets/services/envcoating.png";
import Industrial from "../../assets/services/industrial.png";
import Watertank from "../../assets/services/watertank.png";
import Publicbuildings from "../../assets/services/publicbuildings.png";

import Save from "../../assets/projects/save.png";
import ChevronLeft from "../../assets/projects/chevron-left.png";

//projects
import embassy1 from "../../assets/projects/embassy/1.jpg";
import embassy2 from "../../assets/projects/embassy/2.jpg";
import embassy3 from "../../assets/projects/embassy/3.jpg";
import fourSeasonResidancy1 from "../../assets/projects/four-season-residancy/1.jpg";
import fourSeasonResidancy2 from "../../assets/projects/four-season-residancy/2.jpg";
import fourSeasonResidancy3 from "../../assets/projects/four-season-residancy/3.jpg";
import fourSeasonResidancy4 from "../../assets/projects/four-season-residancy/4.jpg";
import hawre1 from "../../assets/projects/hawre/1.jpg";
import hawre2 from "../../assets/projects/hawre/2.jpg";
import hawre3 from "../../assets/projects/hawre/3.jpg";
import hawre4 from "../../assets/projects/hawre/4.jpg";
import hawre5 from "../../assets/projects/hawre/5.jpg";
import megaMall1 from "../../assets/projects/mega-mall/1.jpg";
import megaMall2 from "../../assets/projects/mega-mall/2.jpg";
import megaMall3 from "../../assets/projects/mega-mall/3.jpg";
import metroMall1 from "../../assets/projects/metro-mall/1.jpg";
import metroMall2 from "../../assets/projects/metro-mall/2.jpg";
import metroMall3 from "../../assets/projects/metro-mall/3.jpg";
import metroMall4 from "../../assets/projects/metro-mall/4.jpg";
import milleniumMall1 from "../../assets/projects/millenium-mall/1.jpg";
import milleniumMall2 from "../../assets/projects/millenium-mall/2.jpg";
import milleniumMall3 from "../../assets/projects/millenium-mall/3.jpg";
import milleniumMall4 from "../../assets/projects/millenium-mall/4.jpg";
import raghavChs1 from "../../assets/projects/raghav-chs/1.jpg";
import raghavChs2 from "../../assets/projects/raghav-chs/2.jpg";
import raghavChs3 from "../../assets/projects/raghav-chs/3.jpg";
import siyaramMill1 from "../../assets/projects/siyaram-mill/1.jpg";
import siyaramMill2 from "../../assets/projects/siyaram-mill/2.jpg";
import siyaramMill3 from "../../assets/projects/siyaram-mill/3.jpg";
import siyaramMill4 from "../../assets/projects/siyaram-mill/4.jpg";
import thakurCollege1 from "../../assets/projects/thakur-college/1.jpg";
import thakurCollege2 from "../../assets/projects/thakur-college/2.jpg";
import thakurCollege3 from "../../assets/projects/thakur-college/3.jpg";

import tarapur1 from "../../assets/projects/tarapur/1.jpg";
import tarapur2 from "../../assets/projects/tarapur/2.jpg";
import tarapur3 from "../../assets/projects/tarapur/3.jpg";

import raymond1 from "../../assets/projects/raymond/1.jpg";
import raymond2 from "../../assets/projects/raymond/2.jpg";
import raymond3 from "../../assets/projects/raymond/3.jpg";

import HomeBg from "../../assets/slider/11.jpg";
import AboutBg from "../../assets/slider/7.jpg";
import ProjectsBg from "../../assets/slider/1.jpg";
import ClientBg from "../../assets/slider/8.jpg";
import ContactBg from "../../assets/slider/12.jpg";

export const AssetsList = {
  logo: {
    Logo,
    LogoSvg,
  },
  bg: Bg,
  client: Clients,
  signFormIcon: SignupFormIcon,
  services: {
    Retro,
    Waterproofing,
    Envcoating,
    Industrial,
    Watertank,
    Publicbuildings,
  },
  save: Save,
  chevron: {
    left: ChevronLeft,
  },
  titleBg: {
    home: HomeBg,
    about: AboutBg,
    projects: ProjectsBg,
    clients: ClientBg,
    contact: ContactBg,
  },
  projects: {
    embassy: {
      embassy1,
      embassy2,
      embassy3,
    },
    fourSeasonResidancy: {
      fourSeasonResidancy1,
      fourSeasonResidancy2,
      fourSeasonResidancy3,
      fourSeasonResidancy4,
    },
    hawre: {
      hawre1,
      hawre2,
      hawre3,
      hawre4,
      hawre5,
    },
    megaMall: {
      megaMall1,
      megaMall2,
      megaMall3,
    },
    metroMall: {
      metroMall1,
      metroMall2,
      metroMall3,
      metroMall4,
    },
    milleniumMall: {
      milleniumMall1,
      milleniumMall2,
      milleniumMall3,
      milleniumMall4,
    },
    raghavChs: {
      raghavChs1,
      raghavChs2,
      raghavChs3,
    },
    siyaramMill: {
      siyaramMill1,
      siyaramMill2,
      siyaramMill3,
      siyaramMill4,
    },
    thakurCollege: {
      thakurCollege1,
      thakurCollege2,
      thakurCollege3,
    },
    tarapur: {
      tarapur1,
      tarapur2,
      tarapur3,
    },
    raymond: {
      raymond1,
      raymond2,
      raymond3,
    },
  },
};
